import { render, staticRenderFns } from "./redeliver-tab.vue?vue&type=template&id=1e208a7a"
import script from "./redeliver-tab.vue?vue&type=script&lang=js"
export * from "./redeliver-tab.vue?vue&type=script&lang=js"
import style0 from "./redeliver-tab.vue?vue&type=style&index=0&id=1e208a7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports